// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__QbGn8","employee-header__buttons":"Header_employee-header__buttons__pR72K","employee-header-item":"Header_employee-header-item__Y9GUa"};